// extracted by mini-css-extract-plugin
export default {"StarMax":"XGYV2","icon":"QJLR1","iconFull":"G3YK0","iconEmpty":"ECi16"};